export const STATE_OPTIONS = {
    initial: "initial",
    loading: "loading",
    success: "success",
};
